/**
 * Series Color 선택 Modal 관련 기능 구현
 *   - Modal Open
 *   - 확인 클릭시 처리
 */

import BriqueChart from './BriqueChart'

// import BriqueChart from './BriqueChart.vue'
// import { ToastProgrammatic as Toast } from 'buefy'

export default {
  /**
   * Color 선택 모달 대화 상자를 open하고 데이터를 세팅한다.
   * @param {Object} element Chart Element
   * @param {String} seriesName Series Name
   */
  openChartModalColor (element, seriesName) {
    element.parentElement.__vue__.chartModalColor.visible = true
    element.parentElement.__vue__.chartModalColor.chartData = element.briqueChartData.tracesOriginal
    element.parentElement.__vue__.chartModalColor.seriesName = seriesName
    element.parentElement.__vue__.chartModalColor.beforeColor = element.briqueChartData.getSeriesColor(element, seriesName)
  },

  /**
     * Color 선택 모달에서 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     * @param {Object} chartVue Chart Vuew Object
     * @param {String} seriesName Series Name
     * @param {Object} colors 선택된 색
     */
  onClickConfirmButtonInModalColor (returnObject, chartVue, seriesName, colors) {
    let element = chartVue.$el.children[0]
    element.briqueChartData.setSeriesStyle(
      seriesName,
      {
        line: { // line chart
          color: colors.hex8 ?? colors
        },
        marker: { // scatter chart
          color: colors.hex8 ?? colors
        },
        fillcolor: colors.hex8 ?? colors // area chart
      }) // Color Picker에서 선택하지 않은 경우에는 colors는 '#FF0000'처럼 문자열이다.

    BriqueChart.react(element, element.data)
  }

}
